import { Specialists, Directions } from '@/components';
import { StyledContent } from '@/components/styles';
import { usePromise } from '@/hooks';
import { useRef, useState, useEffect } from 'react';
import api from '@/lib/api';
import axios from 'axios';

export default function Doctors({ data, swiperData, ...props }) {
  const [direction, setDirection] = useState({});

  const { gallerySwiper } = swiperData;

  const updateSwiper = () => {
    if (gallerySwiper && gallerySwiper !== null && gallerySwiper.controller) {
      gallerySwiper.update();
    }
  };

  const cancelTokenSource = useRef(axios.CancelToken.source());
  const directionsPromise = usePromise(
    () =>
      api.directions({
        ...direction,
        cancelToken: cancelTokenSource.token,
      }),
    [direction],
    props,
    () => cancelTokenSource.current.cancel()
  );

  const defaultDirection = {
    id: 'all',
    title: 'All directions',
    service_count: 1,
    slug: 'all',
    subdirections: [],
  };

  const { directions, current_direction: currentDirection, specialists } = directionsPromise.result;
  const loading = directionsPromise.status === 'pending';

  const handleClick = (slug) => {
    setDirection({
      direction: slug,
    });
  };

  useEffect(() => {
    if (directions?.length && !loading) {
      updateSwiper();
    }
  }, [directions, loading]);

  return (
    <>
      {!!directions?.length && (
        <div className="no-content-swiping">
          <Directions directions={[defaultDirection, ...directions]} active={currentDirection} onClick={handleClick} size="mid" />
        </div>
      )}
      <StyledContent.Loadable isLoading={loading}>
        {!!specialists?.length && <Specialists data={specialists} />}
      </StyledContent.Loadable>
    </>
  );
}
